<template>
  <div class="clearfix" v-if="!loader">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="loader" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">       
      </div>
      <div class="d-sm-flex align-items-center" v-if="type_of_task!='default'">
        <div>
          <div class="select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0">
            <button
              class="default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
              type="button"
              style="background-color: #EB9355;" 
              data-bs-toggle="modal"
              data-bs-target="#filterLeadModal" 
              @click="showScreen('REJECTED','Voulez-vous vraiment annuler ce transfert ?')"  
              v-if="current_permissions('validate_payout_transaction')"        
            >       
              {{ $t('validation.cancel') }}
              <i class="flaticon-close position-relative ms-5 top-2 fs-15"></i>
            </button>
          </div>
        </div>   
        <button
          class="default-outline-btn position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"                  
          style="background-color: #EB9355;" 
          data-bs-toggle="modal"
          data-bs-target="#filterLeadModal"       
          @click="showScreen('VALIDATED','Voulez-vous vraiment confirmer ce transfert ?')"
          v-if="current_permissions('validate_payout_transaction')"
        >
          {{ $t('validation.confirm') }}
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <!-- Barre de recherche -->
      <div class="row mb-15 mb-sm-20 mb-md-25">
        <div class="col-md-4">
          <div class="position-relative">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
              :placeholder="$t('validation.search')"
            />
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table id="" class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('validation.code') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('validation.beneficiary') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('validation.operator') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('validation.phone') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('validation.amount') }}
              </th> 
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('validation.date') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('validation.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <!--
              IMPORTANT : chaque transaction est désormais affichée sur sa propre ligne.
              On n'agrège/ne cumule plus par intBulkId : s'il y a 3 transactions initiées
              dans un même lot, on voit bien 3 lignes distinctes avec leur montant individuel.
            -->
            <tr v-for="(transaction) in paginatedTransactions" :key="transaction.payoutId">
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ transaction.payoutId}}
                  </div>
                </div>
              </th>
              <!--
                Correction : payoutType n'existe pas dans les données renvoyées par
                l'API, donc les deux <td> conditionnelles précédentes ne s'affichaient
                jamais et décalaient toutes les colonnes suivantes d'un cran.
                On affiche désormais toujours une seule cellule Bénéficiaire.
              -->
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.clientId || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.operator.mnoName}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.contact}}
              </td>
              <!-- Montant individuel de la transaction (plus de cumul via bulkTotalAmount) -->
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.amount.toLocaleString() }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatDateFr(new Date(transaction.transactionDate))}}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="transaction.paymentStatus==='SUCCEEDED'">{{ $t('validation.success') }}</span>
                <span class="badge text-outline-danger" v-if="transaction.paymentStatus==='FAILED'">{{ $t('validation.failed') }}</span>
                <span class="badge text-outline-info" v-if="transaction.paymentStatus==='PROCESSING'">{{ $t('validation.processing') }}</span>
                <span class="badge text-outline-info" v-if="transaction.paymentStatus==='PENDING'">{{ $t('validation.pending') }}</span>
                <span class="badge text-outline-info" v-if="transaction.paymentStatus==='INITIATED'">{{ $t('validation.initiated') }}</span>
                <span class="badge text-outline-info" v-if="transaction.paymentStatus==='SCHEDULED'">{{ $t('validation.scheduled') }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu" v-if="type_of_task=='default'">
                    <li>
                      <a data-bs-toggle="modal" data-bs-target="#filterLeadModal1" @click="showScreenIndividual('VALIDATED','Voulez-vous vraiment confirmer ce transfert ?',(transaction.payoutType==2)?transaction.intBulkId:transaction.payoutId,transaction.payoutType)" class="dropdown-item d-flex align-items-center position-relative transition border-0 fw-medium text-black pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0" type="button" v-if="current_permissions('validate_payout_transaction')">
                        <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
                        {{ $t('validation.confirm') }}
                      </a>
                    </li>
                    <li>
                      <a data-bs-toggle="modal" v-if="current_permissions('validate_payout_transaction')" data-bs-target="#filterLeadModal1" @click="showScreenIndividual('REJECTED','Voulez-vous vraiment annuler ce transfert ?',(transaction.payoutType==2)?transaction.intBulkId:transaction.payoutId,transaction.payoutType)" type="button" class="dropdown-item d-flex align-items-center position-relative transition border-0 fw-medium text-black pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0">
                        <i class="flaticon-close position-relative ms-5 top-2 fs-15"></i>
                        {{ $t('validation.cancel') }}
                      </a>
                    </li> 
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>pageSize" class="mb-0 text-paragraph">
          {{ $t('validation.showing') }} <span class="fw-bold">{{ showingFrom }}-{{ showingTo }}</span> {{ $t('validation.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('validation.results') }}
        </p>
        <p v-if="filteredTotal<=pageSize" class="mb-0 text-paragraph">
          {{ $t('validation.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('validation.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('validation.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="goToPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="goToPage(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="goToPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
 
  <!-- Modal confirmation -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true" style="z-index: 9999;">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ $t('validation.alert') }}</h1>                
          <button type="button" class="btn-close" id="close" data-bs-dismiss="modal" aria-label="Close" @click="cancel()"></button>
        </div>
        <div class="modal-body">
          <div style="">
            <h6 v-if="status=='REJECTED' && errors==''" class="text-red fw-bold mb-0 text-center" style="color: red;">{{ message}}</h6>
            <h6 v-if="status=='VALIDATED' && errors==''" class="text-success fw-bold mb-0 text-center" style="color: red;">{{ message}}</h6>
          </div>
          <div v-if="errors!==''">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">code: {{ errorId}}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>              
          </div>
        </div>
        <div class="modal-footer">                
          <button type="button" class="btn default-outline-btn bg-transparent" style="background-color: #FFF;" data-bs-dismiss="modal" @click="cancel()">
            {{ $t('validation.no') }}
          </button>               
          <button :disabled="!btnLoad" type="button" class="btn" style="background-color: #EB9355;" @click="storeTransfert()">           
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('validation.yes') }}</span> 
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal individual confirmation -->
  <div class="modal fade" id="filterLeadModal1" tabindex="-1" aria-hidden="true" style="z-index: 9999;">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ $t('validation.alert') }}</h1>                
          <button type="button" class="btn-close" id="close" data-bs-dismiss="modal" aria-label="Close" @click="cancel()"></button>
        </div>
        <div class="modal-body">
          <div style="">
            <h6 v-if="status=='REJECTED' && errors==''" class="text-red fw-bold mb-0 text-center" style="color: red;">{{ message}}</h6>
            <h6 v-if="status=='VALIDATED' && errors==''" class="text-success fw-bold mb-0 text-center" style="color: red;">{{ message}}</h6>
          </div>
          <div v-if="errors!==''">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">code: {{ errorId}}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>              
          </div>
          <div class="table-responsive" style="margin-top: 1%;" v-if="transaction1s.length>0">
            <table id="" class="table text-nowrap align-middle mb-0">
              <thead>
                <tr>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                    {{ $t('validation.beneficiary') }}
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                    {{ $t('validation.operator') }}
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                    {{ $t('validation.phone') }}
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                    {{ $t('validation.amount') }}
                  </th> 
                </tr>
              </thead>
              <tbody>
                <tr v-for="(transaction1) in transaction1s" :key="transaction1.payoutId">
                  <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                    {{ transaction1.clientId}}
                  </td>
                  <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                    {{ transaction1.operator.mnoName}}
                  </td>
                  <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                    {{ transaction1.contact}}
                  </td>
                  <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                    {{transaction1.amount.toLocaleString()}}
                  </td>
                  <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                    {{ formatDateFr(new Date(transaction1.transactionDate))}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">                
          <button type="button" class="btn default-outline-btn bg-transparent" style="background-color: #FFF;" data-bs-dismiss="modal" @click="cancel()">
            {{ $t('validation.no') }}
          </button>               
          <button :disabled="!btnLoad" type="button" class="btn" style="background-color: #EB9355;" @click="storeTransfert()">           
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('validation.yes') }}</span> 
          </button>
        </div>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup  lang="ts">

import {ref, onMounted,onBeforeMount,inject  } from "vue";
import { useRoute} from 'vue-router'
import axios from 'axios';
import flatpickr from "flatpickr";
import { useI18n } from "vue-i18n";
import html2pdf from "html2pdf.js";
import LeadscontentPdf from "./LeadsContentPdf.vue";
import router from '../../../router/index'
import conf from '../../../../env.json'
import {current_permissions} from '../../../utils/permission';
import{showToast,checkSessionValidate} from '../../../utils/function'
import { useTableFilter } from "../../../utils/UseTablefilter";
const backApi=inject('back');
let role: string|null = localStorage.getItem('role');

declare interface Transaction {
    id: number,
    payoutId: string,
    clientId: string,
    operator: string,
    contact: string,
    amount: string,    
    transactionDate: string,
    paymentStatus: string,
    payoutType:number,
    validationStatus:string,
    bulkTotalAmount:string,
    intBulkId:string
}

declare interface Organization {
  id : string,
  code: string,
  name: string,
  description: string,    
  email: string,
  created_at: string
}

declare interface Operator {
  id : string,
  code: string,
  mnoName: string,
  status: string,    
  countryCode: string  
}
let url = '';
  if (role == 'SUPERADMIN' || role == 'BUSINESS' || role == 'SUPPORT') {
    url = backApi + '/secure/transactions/extended';
  } else {
    url = backApi + '/secure/transactions';
  }



const leadPlaceholder = "Select date";
const { t } = useI18n();
let data = [];
let beginDate = ref('');
let endDate = ref('');
let today = ref('');
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedStatus = ref('');
const loader = ref(false);
const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const amount = ref(0);
const operator = ref('');
const paymentStatus = ref(''); 
const status = ref(''); 
const message = ref(''); 
const btnLoad = ref(true);
const errors = ref('');
const errorId = ref('');
let type_of_task = 'default'
    
const transactions =ref(new Array<Transaction>());
const transaction1s =ref(new Array<Transaction>());
const organizations =ref(new Array<Organization>());
const operators =ref(new Array<Operator>());
let operatorsTemp =new Array<Operator>();
const transaction =ref({} as Transaction);

let transactionId:string|null;
let idType:string|null;

  function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

function formatDateEn(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}

function formatDateEnBis(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}

function paymentStatusLabelOf(pStatus: string) {
  if (pStatus === 'SUCCEEDED') return t('validation.success');
  if (pStatus === 'FAILED') return t('validation.failed');
  if (pStatus === 'PROCESSING') return t('validation.processing');
  if (pStatus === 'PENDING') return t('validation.pending');
  if (pStatus === 'INITIATED') return t('validation.initiated');
  if (pStatus === 'SCHEDULED') return t('validation.scheduled');
  return '';
}

// Montant affiché : toujours le montant individuel de la transaction.
// On n'utilise plus bulkTotalAmount puisque les transactions ne sont
// plus regroupées/cumulées par lot : chaque ligne = une transaction.
function displayedAmountOf(tr: Transaction) {
  return tr.amount;
}

const {
  searchQuery,
  paginatedData: paginatedTransactions,
  filteredTotal,
  page,
  numPages,
  pageSize,
  showingFrom,
  showingTo,
  goToPage,
} = useTableFilter(
  transactions,
  [
    (tr: Transaction) => tr.payoutId,
    (tr: Transaction) => tr.clientId,
    (tr: Transaction) => tr.operator?.mnoName,
    (tr: Transaction) => tr.contact,
    (tr: Transaction) => displayedAmountOf(tr),
    (tr: Transaction) => tr.transactionDate ? formatDateFr(new Date(tr.transactionDate)) : '',
    (tr: Transaction) => paymentStatusLabelOf(tr.paymentStatus),
  ],
  15
);

const cancel = () =>{
  status.value="";
  errorId.value="";
  errors.value="";
}

function handleOrganizationChange(event) {
      selectedOrganization.value = event.target.value;
    }

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleStatusChange(event) {
  selectedStatus.value = event.target.value;
}

function handleCountryChange(event) {
  // // selectedStatus.value = event.target.value;
  // operators
  var j = 0;
  var operatorArr = new Array<Operator>();
  while(j<operatorsTemp.length){    
      if(operatorsTemp[j].countryCode == event.target.value){         
          operatorArr.push(operatorsTemp[j]);
      }      
      j++;
  }
   operators.value = operatorArr;
}
    

onMounted(() => {
  checkSessionValidate(1)
 // loader.value=false; 
//  alert(window.history.back())

const route = useRoute();
transactionId = route.params.transactionId;  
idType = route.params.idType; 
if(transactionId!='default'){
  type_of_task = 'individual'
} 
// alert(transactionId);
// alert(idType);

  getTransactions();
 
  setTimeout(function () {
    //loader.value=true; 
        flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
        enableTime: true,
      });
        },1000);

 

  flatpickr("#basic-calendar", {
    dateFormat: "Y-m-d H:i",
  });

});
const token =  localStorage.getItem('login_token');
const loadTransaction = (code)=>{
  
  axios.get(`${url}/${code}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transaction.value = response.data;  //.data.users   
        // data  = response.data.transactions;  
        operator.value=  response.data.operator.mnoName;
        amount.value= response.data.amount.toLocaleString();
       
         if(response.data.paymentStatus==='SUCCEEDED'){
          paymentStatus.value = "SUCCESS"
         }else if(response.data.paymentStatus==='PROCESSING'){
          paymentStatus.value = "EN COURS"
         }else if(response.data.paymentStatus==='PENDING'){
          paymentStatus.value = "EN ATTENTE"
         }else if(response.data.paymentStatus==='INITIATED'){
          paymentStatus.value = "INITIÉ"
         }else if(response.data.paymentStatus==='SCHEDULED'){
          paymentStatus.value = "PLANIFIÉ"
         }else{
          paymentStatus.value = "ECHEC"
         }   
         
        loader.value=true;
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }   
              
          }
  });
}

const getTransactions = (arg=1) =>{
    loader.value=false;
    gettran.value = true;
    search.value = false;
    search1.value = false;

    if(type_of_task!='default'){
      let param = `${idType}=${transactionId}`;
      axios.get(`${url}?${param}`,{
          headers: {
              Authorization: `Bearer ${token}`
          }
      })
      .then((response) => {
          transactions.value = response.data.data;
          loader.value=true;
      }).catch((error) => {
          loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }
          }
      });
      return;
    }

    const paramInitiated = "paymentStatus=INITIATED&validationStatus=DRAFT&publicToken=null";
    const paramProcessing = "paymentStatus=PROCESSING&validationStatus=DRAFT&publicToken=null";

    Promise.all([
      axios.get(`${url}?${paramInitiated}`, {
        headers: { Authorization: `Bearer ${token}` }
      }),
      axios.get(`${url}?${paramProcessing}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
    ])
    .then(([responseInitiated, responseProcessing]) => {
        const merged = [
          ...(responseInitiated.data.data || []),
          ...(responseProcessing.data.data || [])
        ];
        merged.sort((a, b) => new Date(b.transactionDate).getTime() - new Date(a.transactionDate).getTime());
        
        transactions.value = merged;
        loader.value=true;
    }).catch((error) => {
        loader.value=true;
        if( error.response){
            console.log(error.response.data);
            if(error.response.status === 401){
              router.push('/');
            }
        }
    });

}

const showPendingTransactions = () =>{
        
    

    //conf.proxy
    axios.get(`${url}?${idType}=${transactionId}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
          transaction1s.value = response.data.data; 
               
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                 router.push('/');
              }   
              
          }
  });

}

const getOrganizations = () =>{

    axios.get(backApi+'/secure/organizations/',{  
      headers: {
           
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {
        // users.value = response.data;
        organizations.value = response.data;  //.data.users          
        console.log(response.data);
        
        
    }).catch((error) => {
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/')
                //window.location.href = '/';
                //router.push('/');
              }   
              
          }
   });
}
const getOperators = () =>{

axios.get(backApi+'/public/operators/',{ 
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    operatorsTemp = response.data;         
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data);
          if(error.response.status === 401){
            router.push('/')
            
          }   
          
      }
});
//  loader.value=true;
}

const showScreen = (statut,msg)=>{ 
  status.value=statut;
  message.value=msg;
}

const showScreenIndividual = (statut,msg,payoutid,payoutType)=>{ 
  status.value=statut;
  message.value=msg;
  transactionId=payoutid;
  idType=(payoutType==2)?'intBulkId':'payoutId';
  transaction1s.value=[];
  if(payoutType==2){
    showPendingTransactions()
  }
  
}

const storeTransfert =()=>{
try {  
  
  axios.post(`${url}/validate`,{
    transactionId:transactionId,
    idType:idType,
    status:status.value
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => { 
        
        if(response.status === 201){  
          router.go();
          showToast("Transfert réussi","green");
          status.value='';
          setTimeout(() => {
            router.go();
            // router.push('/transferts'); 
            }, 4000);          
           
        }      
        
    }).catch((error) => {
          if( error.response){
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              }    
              
          }
  });
} catch (error) {
        console.error(error);        
         errors.value="une erreur inattendue est apparue"
      
}

}

</script>
<style scoped>
#title{
 text-decoration: underline;
 margin-bottom: 2%;
}
#transactionsTable{
 display: none; 
 /* visibility: hidden;*/
}

.modal {
  z-index: 9999 !important;
}

.modal-backdrop {
  z-index: 9998 !important;
}

.dropdown-menu {
  z-index: 10000 !important;
}
</style>